import { z } from "zod";

import i18n from "../../../../i18n";
import { LocationData } from "../../../../models/LocationData";

const t = (key: string) =>
  i18n.t(`facilityDetailsPage.modalEditProfile.addressForm.errors.${key}`);

export const schema = z.object({
  regionCode: z.string().max(10, t("regionCode.maxLength")).optional(),
  postalCode: z.string().max(20, t("postalCode.maxLength")).optional(),
  administrativeArea: z
    .string()
    .max(100, t("administrativeArea.maxLength"))
    .optional(),
  locality: z.string().max(100, t("locality.maxLength")).optional(),
  sublocality: z.string().max(100, t("sublocality.maxLength")).optional(),
  addressLines: z.array(z.object({ line: z.string() })),
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (data: LocationData): Schema => {
  const storefrontAddress = data.location_address;

  const addressLinesRaw = storefrontAddress?.address_lines;
  const addressLinesArray =
    typeof addressLinesRaw === "string"
      ? JSON.parse(addressLinesRaw || "[]")
      : Array.isArray(addressLinesRaw)
      ? addressLinesRaw
      : [""];

  return {
    regionCode: storefrontAddress?.country_code || "",
    postalCode: storefrontAddress?.postal_code || "",
    administrativeArea: storefrontAddress?.administrative_area || "",
    locality: storefrontAddress?.locality || "",
    sublocality: storefrontAddress?.sublocality || "",
    addressLines: addressLinesArray.map((line: string) => ({ line })),
  };
};
